module.exports = "https://static.wmbcdn.com/uniweb/images/c178ecfbbf3b26366f07fcaf8bf2e904.jpg";